import React from 'react';
import cx from 'classnames';

import tickIcon from '../../../media/icons/tick.svg';

const ColourPicker = ({ newColour, setNewColour, description }) => {
  return (
    <div className="text-base mt-8 mb-4">
      {description}
      <div className="mt-4 flex justify-between">
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#60768D',
            'm-[2px]': newColour !== '#60768D',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#60768D')}
            className="w-10 h-10 bg-[#60768D] m-1 rounded-lg"
          />
          {newColour === '#60768D' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#FF6663',
            'm-[2px]': newColour !== '#FF6663',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#FF6663')}
            className="w-10 h-10 bg-[#FF6663] m-1 rounded-lg"
          />
          {newColour === '#FF6663' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#FF9900',
            'm-[2px]': newColour !== '#FF9900',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#FF9900')}
            className="w-10 h-10 bg-[#FF9900] m-1 rounded-lg"
          />
          {newColour === '#FF9900' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#E9BE00',
            'm-[2px]': newColour !== '#E9BE00',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#E9BE00')}
            className="w-10 h-10 bg-[#E9BE00] m-1 rounded-lg"
          />
          {newColour === '#E9BE00' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#009383',
            'm-[2px]': newColour !== '#009383',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#009383')}
            className="w-10 h-10 bg-[#009383] m-1 rounded-lg"
          />
          {newColour === '#009383' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#00D193',
            'm-[2px]': newColour !== '#00D193',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#00D193')}
            className="w-10 h-10 bg-[#00D193] m-1 rounded-lg"
          />
          {newColour === '#00D193' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#37C2D7',
            'm-[2px]': newColour !== '#37C2D7',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#37C2D7')}
            className="w-10 h-10 bg-[#37C2D7] m-1 rounded-lg"
          />
          {newColour === '#37C2D7' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#559FF8',
            'm-[2px]': newColour !== '#559FF8',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#559FF8')}
            className="w-10 h-10 bg-[#559FF8] m-1 rounded-lg"
          />
          {newColour === '#559FF8' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#D678FB',
            'm-[2px]': newColour !== '#D678FB',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#D678FB')}
            className="w-10 h-10 bg-[#D678FB] m-1 rounded-lg"
          />
          {newColour === '#D678FB' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
        <div
          className={cx('relative w-13 h-13', {
            'border-2 border-black rounded-lg': newColour === '#A144C6',
            'm-[2px]': newColour !== '#A144C6',
          })}
        >
          <button
            type="button"
            onClick={() => setNewColour('#A144C6')}
            className="w-10 h-10 bg-[#A144C6] m-1 rounded-lg"
          />
          {newColour === '#A144C6' && (
            <div className="absolute bg-white/30 rounded-full p-3 top-0 right-1/2 translate-1/2">
              <img
                className="w-3 h-3 absolute top-0 right-1/2 translate-1/2"
                src={tickIcon}
                alt=""
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ColourPicker;
